export default "__VITE_ASSET__JaSlFpoU__"